import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";
import PatchLists from "../../patchlists.js";
import PatchListModalDialog from "../../patchlists_modaldialog.js";

export default class PageOp
{
    constructor(targetElement)
    {
        // targetEl, opName, userIsStaff, isUserOp, userIsCreator, exampleId, sandboxUrl
        let opName = targetElement.dataset.opName;
        let isUserOp = targetElement.dataset.isUserOp;
        let userIsCreator = targetElement.dataset.userIsCreator;
        let exampleId = targetElement.dataset.exampleId;
        let sandboxUrl = targetElement.dataset.sandboxUrl;

        this.patchListModal = new PatchListModalDialog();
        this.patchLists = new PatchLists();
        this._settings = { "lastFilter": "", "defaultTab": "opexamples" };

        if (isUserOp) this._settings.defaultTab = "mine";
        if (!userIsCreator) this._settings.defaultTab = "public";
        this._settings.opName = opName;

        if (exampleId)
        {
            web.embedPatch({
                "projectId": exampleId,
                "elementId": "opexamplecontainer",
                "sandboxUrl": sandboxUrl,
                "focusPatch": false
            });
        }

        if (web.env.isDev())
        {
            api.get("op/" + opName + "/find", (r) =>
            {
                if (r.data && r.data.environments && !r.data.environments.includes("cables.gl"))
                {
                    ele.byId("opLiveVersion").innerHTML = "<span style=\"color:var(--info)\">this exact op does not exist on cables.gl!</span>";
                }
            });
        }

        api.get("op/" + opName + "/count", (result) =>
        {
            if (result && result.data)
            {
                const tabs = ele.byQueryAll("#patchtabs li");
                let firstActive = !!ele.byQuery(".examplepatchlist");

                for (let r in result.data)
                {
                    const numElement = ele.byId("num_" + r);
                    if (numElement)
                    {
                        const count = result.data[r];
                        numElement.innerText += " (" + count + ")";
                        const tabElement = numElement.closest("li");
                        tabElement.dataset.count = count;
                        if (tabElement)
                        {
                            if (count > 0 || count === "100+")
                            {
                                ele.show(tabElement);
                                if (!web.tabs.requestedTabExists(tabs) && !firstActive)
                                {
                                    web.tabs.activateTab(tabs, tabElement, false);
                                    firstActive = true;
                                }
                            }
                            else
                            {
                                if (web.tabs.isRequestedTab(tabs, tabElement))
                                {
                                    ele.show(tabElement);
                                }
                                else
                                {
                                    ele.hide(tabElement);
                                }
                            }
                        }
                    }
                }
            }
        });
    }

    getPatches(targetEl)
    {
        const opName = this._settings.opName;
        let which = targetEl.dataset.tabName;
        const headerLink = targetEl.dataset.headerLink;

        let url = new URL(window.location.href);
        let w = url.searchParams.get("w") || this._settings.defaultTab;
        let limit = url.searchParams.get("l") || 12;
        let offset = url.searchParams.get("o") || 0;
        this._settings.lastFilter = w;

        const numPrivate = ele.byId("num_private");
        if (numPrivate) ele.hide(numPrivate);

        let patchesUrl = "op/" + opName + "/examples";
        let id = "opexamples";
        let containerId = "results_container";
        let emptyText = "No Patches found";

        switch (which)
        {
        case "teampatches":
            patchesUrl = "op/" + opName + "/teampatches";
            id = "teampatches";
            break;
        case "private":
            patchesUrl = "op/" + opName + "/privatepatches";
            id = "private";
            if (numPrivate) numPrivate.classList.remove("hidden");
            break;
        case "public":
            patchesUrl = "op/" + opName + "/patches";
            id = "public";
            break;
        case "mine":
            patchesUrl = "op/" + opName + "/mypatches";
            id = "mine";
            break;
        }

        limit = Number(limit);
        offset = Number(offset);
        if (limit || limit === 0)
        {
            patchesUrl += "?l=" + limit;
        }
        if (offset)
        {
            patchesUrl += "&o=" + offset;
        }

        api.get(patchesUrl, (result) =>
        {
            let html = "";
            if (headerLink)
            {
                html = web.getHandleBarHtml("project_list_headline_teampatches", { "link": headerLink });
            }
            web.projectPagePatchList(result.projects, id, emptyText, result.pagination, "project", html);
            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId(containerId), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "?w=" + which;
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "&l=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&o=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + "#" + which;
                });
            }
        });
    }

    getSubPatches(targetEl, fromUserInteraction = false)
    {
        const opName = this._settings.opName;
        let which = targetEl.dataset.tabName;

        let url = new URL(window.location.href);
        let w = url.searchParams.get("w") || this._settings.defaultTab;
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o") || 0;
        this._settings.lastFilter = w;

        const numPrivate = ele.byId("num_private");
        if (numPrivate) ele.hide(numPrivate);

        let patchesUrl = "op/" + opName + "/subpatchops";
        let containerId = "results_container";

        limit = Number(limit);
        offset = Number(offset);
        if (limit || limit === 0)
        {
            patchesUrl += "?l=" + limit;
        }
        if (offset)
        {
            patchesUrl += "&o=" + offset;
        }

        api.get(patchesUrl, (result) =>
        {
            let html = "";
            result.data.forEach((op) =>
            {
                html += web.getHandleBarHtml("op", op);
            });
            ele.byId("ops").innerHTML = html;
            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId(containerId), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "?w=" + which;
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "&l=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&o=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + "#ops";
                });
            }
        });
    }

    addChangelog(button, name)
    {
        web.buttons.startSavingAnimButton(button);
        const message = ele.byId("newchangelog").value;
        const type = ele.byId("newchangelogtype").value;
        const update = ele.byId("updatechangelog").value === "true";
        const date = ele.byId("changelogdate").value;
        const newDate = ele.byId("newchangelogdate");
        const data = {
            "message": message,
            "type": type,
            "date": date
        };
        if (update)
        {
            data.update = true;
            if (newDate && newDate.value !== date) data.newDate = newDate.value;
        }
        api.put(
            "op/changelog/" + name,
            data,
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                document.location.hash = "#changelog";
                document.location.reload();
            }
        );
    }


    save(name)
    {
        let data =
        {
            "op": name,
            "summary": ele.byQuery("#edit_summary input").value,
            "youtubeids": ele.byQuery("#edit_youtubeid input").value,
            "exampleProjectId": ele.byQuery("#edit_exampleprojectid input").value,
            "caniusequery": ele.byQuery("#edit_caniusequery input").value,
            "license": ele.byQuery("#edit_license input").value,
            "doc": ele.byQuery("#edit_doc textarea").value,
            "issues": ele.byQuery("#edit_issues textarea").value,
            "ports": []
        };

        const authorField = ele.byQuery("#edit_author input");
        if (authorField) data.authorName = authorField.value;

        ele.byQueryAll(".edit-port input").forEach((el) =>
        {
            if (el.value && el.dataset.name)
            {
                data.ports.push(
                    {
                        "name": el.dataset.name,
                        "text": el.value
                    });
            }
        });

        api.put(
            "op/" + name,
            data,
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            }
        );
    }

    showDocsEditor()
    {
        ele.hide(ele.byId("op-edit-button"));
        ele.hide(ele.byId("opfacts"));

        ele.show(ele.byId("op-cancel-button"));
        ele.show(ele.byId("op-save-button"));
        ele.show(ele.byId("op-add-patchlist"));
        ele.show(ele.byId("edit_summary"));
        ele.hide(ele.byId("display_summary"));
        ele.show(ele.byId("edit_youtubeid"));
        ele.show(ele.byId("edit_exampleprojectid"));
        ele.show(ele.byId("edit_caniusequery"));
        ele.show(ele.byId("edit_author"));
        ele.show(ele.byId("edit_examplepatchlist"));
        ele.hide(ele.byId("display_doc"));
        ele.hide(ele.byId("display_issues"));
        ele.show(ele.byId("edit_doc"));
        ele.show(ele.byId("edit_issues"));
        ele.hide(ele.byId("display-port"));
        ele.show(ele.byId("edit_license"));

        ele.byQueryAll(".display-port").forEach((e) =>
        {
            ele.hide(e);
        });
        ele.byQueryAll(".edit-port").forEach((e) =>
        {
            ele.show(e);
        });
    }

    hideDocEditor()
    {
        ele.show(ele.byId("op-edit-button"));
        ele.hide(ele.byId("op-cancel-button"));
        ele.hide(ele.byId("op-save-button"));
        ele.hide(ele.byId("op-add-patchlist"));
        ele.show(ele.byId("display_relatedops"));
        ele.hide(ele.byId("edit_summary"));
        ele.show(ele.byId("display_summary"));
        ele.show(ele.byId("display_doc"));
        ele.show(ele.byId("display_issues"));
        ele.hide(ele.byId("edit_doc"));
        ele.hide(ele.byId("edit_youtubeid"));
        ele.hide(ele.byId("edit_exampleprojectid"));
        ele.hide(ele.byId("edit_caniusequery"));
        ele.hide(ele.byId("edit_relatedops"));
        ele.show(ele.byId("edit_author"));
        ele.hide(ele.byId("edit_examplepatchlist"));
        ele.hide(ele.byId("edit_issues"));
        ele.hide(ele.byId("edit_license"));
        ele.byQueryAll(".display-port").forEach((e) =>
        {
            e.classList.remove("hidden");
        });
        ele.byQueryAll(".edit-port").forEach((e) =>
        {
            e.classList.add("hidden");
        });
    }

    getPatchLists(targetEl)
    {
        const listTarget = targetEl || ele.byId("patchlist");
        const listId = targetEl.dataset.listId;
        const headerLink = targetEl.dataset.headerLink;

        const apiUrl = web.tabs.addPagination("patchlists/patches/" + listId, 10);
        api.get(apiUrl, (result) =>
        {
            const projects = result.data;
            let html = "";
            if (headerLink)
            {
                html = web.getHandleBarHtml("project_list_headline_patchlist", { "link": headerLink });
            }
            for (let i = 0; i < projects.length; i++)
            {
                const project = projects[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
                html += web.getHandleBarHtml("patchlist_project", { "project": project, "projectInfo": projectInfo });
            }

            if (listTarget)
            {
                listTarget.innerHTML = html;
                if (!projects || projects.length === 0) listTarget.innerHTML = "<div class=\"cute-12-phone\">No patches in this list (yet).</div>";
            }

            web.tabs.initPagination(listTarget, result.pagination);
        });
    }

    toggleChangelogEntry()
    {
        const form = ele.byId("changelogform");
        if (form)
        {
            if (form.classList.contains("hidden"))
            {
                const newchangelog = ele.byId("newchangelog");
                const newchangelogtype = ele.byId("newchangelogtype");
                const updatechangelog = ele.byId("updatechangelog");
                const changelogdate = ele.byId("changelogdate");
                const newchangelogdatelabel = ele.byId("newchangelogdatelabel");
                const newchangelogdate = ele.byId("newchangelogdate");

                if (newchangelog) newchangelog.value = "";
                if (newchangelogtype) newchangelogtype.value = "feature";
                if (changelogdate) changelogdate.value = "";
                if (updatechangelog) updatechangelog.value = "false";
                if (newchangelogdatelabel) ele.hide(newchangelogdatelabel);
                if (newchangelogdate) newchangelogdate.value = "";
            }
            ele.toggle(form);
        }
    }

    editChangelogEntry(opId, message, type, date)
    {
        const form = ele.byId("changelogform");
        if (form)
        {
            const newchangelog = ele.byId("newchangelog");
            const newchangelogtype = ele.byId("newchangelogtype");
            const updatechangelog = ele.byId("updatechangelog");
            const changelogdate = ele.byId("changelogdate");
            const newchangelogdate = ele.byId("newchangelogdate");
            if (message && newchangelog) newchangelog.value = message;
            if (newchangelogtype)
            {
                newchangelogtype.value = type;
                this.setChangeLogType(type);
            }
            if (date && changelogdate)
            {
                changelogdate.value = date;
            }
            if (updatechangelog) updatechangelog.value = "true";
            if (newchangelogdate)
            {
                const newchangelogdatelabel = ele.byId("newchangelogdatelabel");
                if (newchangelogdatelabel) ele.show(newchangelogdatelabel);
                newchangelogdate.value = date;
            }
            ele.toggle(form);
        }
    }

    deleteChangelogEntry(button, opId)
    {
        web.buttons.startSavingAnimButton(button);
        const changelogdate = ele.byId("changelogdate");
        if (!changelogdate)
        {
            web.buttons.stopSavingAnimButton(button, true, true);
            return;
        }
        const date = changelogdate.value;
        const data = {
            "date": date
        };
        api.delete(
            "op/changelog/" + opId,
            data,
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                document.location.reload();
            },
            (err) =>
            {
                console.error(err);
                web.buttons.stopSavingAnimButton(button, true, true);
            }
        );
    }

    toggleChangelogType(type)
    {
        const featureInput = ele.byId("newchangelogtype");
        if (featureInput)
        {
            let newValue = "";
            if (featureInput.value !== type)
            {
                newValue = type;
            }
            else
            {
                featureInput.value = "";
            }
            this.setChangeLogType(newValue);
        }
    }

    setChangeLogType(type)
    {
        const featureInput = ele.byId("newchangelogtype");
        if (featureInput) featureInput.value = type;
        const typeButtons = ele.byQueryAll("#changelogform .button");
        typeButtons.forEach((button) =>
        {
            button.classList.remove("active");
        });
        if (type)
        {
            const typeButton = ele.byQuery("#changelogform ." + type.replaceAll(" ", "_"));
            if (typeButton) typeButton.classList.add("active");
        }
    }

    adminSetPatchPublic(targetEle)
    {
        web.buttons.startSavingAnimButton(targetEle);
        const patchId = targetEle.dataset.patchid;
        if (!patchId)
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("no patchid given!");
            return;
        }

        api.post("admin/project/" + patchId + "/setpublic", {}, () =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true);
            setTimeout(() =>
            {
                const nonpublicWarning = ele.byId("op_example_warning_nonpublicexample");
                if (nonpublicWarning) ele.hide(nonpublicWarning);
                ele.hide(targetEle);
            }, 400);
        }, (e) =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("error setting patch public", e);
        });
    }

    adminSetPatchCC0(targetEle)
    {
        const patchId = targetEle.dataset.patchid;
        if (!patchId)
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("no patchid given!");
            return;
        }

        api.post("admin/project/" + patchId + "/setcc0", {}, () =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true);
            setTimeout(() =>
            {
                const licenceWarning = ele.byId("op_example_warning_noncc0example");
                if (licenceWarning) ele.hide(licenceWarning);
            }, 400);
        }, (e) =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("error setting patch cc0", e);
        });
    }

    adminAddPatchTeam(targetEle)
    {
        const patchId = targetEle.dataset.patchid;
        const teamid = targetEle.dataset.teamid;
        if (!patchId)
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("no patchid or teamid given! patchid:", patchId, "teamid:", teamid);
            return;
        }

        api.post("admin/project/" + patchId + "/addteam/" + teamid, {}, () =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true);
            setTimeout(() =>
            {
                const teamWarning = ele.byId("op_example_warning_notinopteam");
                if (teamWarning) ele.hide(teamWarning);
            }, 400);
        }, (e) =>
        {
            web.buttons.stopSavingAnimButton(targetEle, true, true);
            console.error("error adding patch to team", e);
        });
    }
}
